// // // import React from 'react';
// // // import { AcademicCapIcon, ClipboardDocumentCheckIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';

// // // const steps = [
// // //   {
// // //     title: "1. Register Your School",
// // //     description: "Begin by creating your school profile with basic details.",
// // //     icon: <AcademicCapIcon className="h-10 w-10 text-indigo-500" />,
// // //   },
// // //   {
// // //     title: "2. Set Up Users",
// // //     description: "Add administrators, teachers, students, and staff easily.",
// // //     icon: <ClipboardDocumentCheckIcon className="h-10 w-10 text-indigo-500" />,
// // //   },
// // //   {
// // //     title: "3. Launch and Monitor",
// // //     description: "Access dashboards, manage schedules, and monitor progress.",
// // //     icon: <RocketLaunchIcon className="h-10 w-10 text-indigo-500" />,
// // //   },
// // // ];

// // // const HowToGetStarted = () => {
// // //   return (
// // //     <section className="bg-white text-gray-800 py-20 px-6 md:px-16">
// // //       <div className="max-w-7xl mx-auto text-center">
// // //         <h2 className="text-4xl font-bold mb-4">How to Get Started</h2>
// // //         <p className="text-gray-600 mb-12 text-lg">
// // //           Follow these 3 simple steps to launch your school ERP platform.
// // //         </p>

// // //         <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-3">
// // //           {steps.map((step, idx) => (
// // //             <div
// // //               key={idx}
// // //               className="bg-gray-50 p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
// // //             >
// // //               <div className="mb-4 flex justify-center">{step.icon}</div>
// // //               <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
// // //               <p className="text-gray-600">{step.description}</p>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default HowToGetStarted;


// // import React from 'react';
// // import {
// //   AcademicCapIcon,
// //   ClipboardDocumentCheckIcon,
// //   RocketLaunchIcon,
// // } from '@heroicons/react/24/outline';

// // const steps = [
// //   {
// //     title: "1. Register Your School",
// //     description: "Begin by creating your school profile with basic details.",
// //     icon: <AcademicCapIcon className="h-10 w-10 text-indigo-400" />,
// //   },
// //   {
// //     title: "2. Upload Documents",
// //     description: "Submit key documents to get your school ready for launch.",
// //     icon: <ClipboardDocumentCheckIcon className="h-10 w-10 text-indigo-400" />,
// //   },
// //   {
// //     title: "3. Launch and Monitor",
// //     description: "Access dashboards, manage schedules, and monitor progress.",
// //     icon: <RocketLaunchIcon className="h-10 w-10 text-indigo-400" />,
// //   },
// // ];

// // const HowToGetStarted = () => {
// //   return (
// //     <section className="bg-gradient-to-r from-[#1e293b] via-[#0f172a] to-[#1e293b] text-white py-20 px-6 md:px-16">
// //       <div className="max-w-7xl mx-auto text-center">
// //         <h2 className="text-4xl font-bold mb-4">🚀 How to Get Started</h2>
// //         <p className="text-gray-300 mb-12 text-lg max-w-2xl mx-auto">
// //           Follow these 3 simple steps to launch your school on <span className="text-indigo-400 font-medium">Isnartech ERP</span> platform.
// //         </p>

// //         <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-3">
// //           {steps.map((step, idx) => (
// //             <div
// //               key={idx}
// //               className="bg-[#1f2937] p-8 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-slate-700"
// //             >
// //               <div className="mb-4 flex justify-center">{step.icon}</div>
// //               <h3 className="text-xl font-semibold mb-2 text-white">{step.title}</h3>
// //               <p className="text-gray-400">{step.description}</p>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default HowToGetStarted;

// import React from 'react';
// import { AcademicCapIcon, ClipboardDocumentCheckIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';

// const steps = [
//   {
//     num: '1',
//     title: 'Register your school',
//     description: 'Create your school profile with a few basic details — it takes about five minutes.',
//     icon: AcademicCapIcon,
//   },
//   {
//     num: '2',
//     title: 'Upload your documents',
//     description: 'Submit the required documents so your school is verified and ready to launch.',
//     icon: ClipboardDocumentCheckIcon,
//   },
//   {
//     num: '3',
//     title: 'Launch and monitor',
//     description: 'Get your subdomain and login, then manage classes and track everything from your dashboard.',
//     icon: RocketLaunchIcon,
//   },
// ];

// const HowToGetStarted = () => {
//   return (
//     <section className="bg-[#F4F8FC] py-20 px-6 md:px-16">
//       <div className="max-w-6xl mx-auto">
//         <div className="text-center max-w-2xl mx-auto mb-16">
//           <h2 className="font-['Fraunces',serif] text-3xl md:text-4xl text-[#101826]">
//             Three steps to launch
//           </h2>
//           <p className="text-[#5A6478] font-['Sora',sans-serif] mt-3 text-lg">
//             From sign-up to a live school portal, without the usual setup drag.
//           </p>
//         </div>

//         <div className="relative grid gap-12 md:grid-cols-3">
//           <div className="hidden md:block absolute top-6 left-[16.5%] right-[16.5%] h-px bg-[#D8DEE9]" />

//           {steps.map((step) => {
//             const Icon = step.icon;
//             return (
//               <div key={step.num} className="relative text-center md:text-left">
//                 <div className="relative z-10 flex md:justify-start justify-center mb-5">
//                   <span className="font-['Fraunces',serif] text-5xl text-[#E8A63C] bg-[#F4F8FC] pr-3">
//                     {step.num}
//                   </span>
//                 </div>
//                 <div className="flex md:justify-start justify-center mb-4">
//                   <Icon className="h-8 w-8 text-[#163863]" />
//                 </div>
//                 <h3 className="font-['Sora',sans-serif] text-xl font-semibold text-[#101826] mb-2">
//                   {step.title}
//                 </h3>
//                 <p className="text-[#5A6478] font-['Sora',sans-serif] leading-relaxed">
//                   {step.description}
//                 </p>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HowToGetStarted;


import React from 'react';
import { AcademicCapIcon, ClipboardDocumentCheckIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';

const steps = [
  {
    num: '1',
    title: 'Register your school',
    description: 'Create your school profile with a few basic details — it takes about five minutes.',
    icon: AcademicCapIcon,
  },
  {
    num: '2',
    title: 'Upload your documents',
    description: 'Submit the required documents so your school is verified and ready to launch.',
    icon: ClipboardDocumentCheckIcon,
  },
  {
    num: '3',
    title: 'Launch and monitor',
    description: 'Get your subdomain and login, then manage classes and track everything from your dashboard.',
    icon: RocketLaunchIcon,
  },
];

const HowToGetStarted = () => {
  return (
    <section className="bg-[#F4F8FC] py-20 px-6 md:px-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="font-['Fraunces',serif] text-3xl md:text-4xl text-[#101826]">
            Three steps to launch
          </h2>
          <p className="text-[#5A6478] font-['Sora',sans-serif] mt-3 text-lg">
            From sign-up to a live school portal, without the usual setup drag.
          </p>
        </div>

        <div className="relative grid gap-12 md:grid-cols-3">
          <div className="hidden md:block absolute top-6 left-[16.5%] right-[16.5%] h-px bg-[#D8DEE9]" />

          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div key={step.num} className="relative text-center md:text-left">
                <div className="relative z-10 flex md:justify-start justify-center mb-5">
                  <span className="font-['Fraunces',serif] text-5xl text-[#E8A63C] bg-[#F4F8FC] pr-3">
                    {step.num}
                  </span>
                </div>
                <div className="flex md:justify-start justify-center mb-4">
                  <Icon className="h-8 w-8 text-[#163863]" />
                </div>
                <h3 className="font-['Sora',sans-serif] text-xl font-semibold text-[#101826] mb-2">
                  {step.title}
                </h3>
                <p className="text-[#5A6478] font-['Sora',sans-serif] leading-relaxed">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowToGetStarted;

